export default function formatMessageContentEventNormal (text) {
    return {
        text
    }
}
